/* eslint-disable @typescript-eslint/no-explicit-any */
// Personal libs
import { apiPost } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { ApiError } from '@shared/error/api.error';
import { manageApiError } from './common/api.lib';
import { IPasswordZxcvbn } from '@shared/interface/password.interface';
import { IAuthRequest } from '@shared/interface/auth-request.interface';

//******************************************************************************** POST
/**
 * Forgotten password
 * @returns
 */
export const apiPostForgottenPass = (params: IAuthRequest): Promise<IApiResponse<string>> => {
  const endpointClass = endpoints.password.postForgottenPass;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string>) => {
      if (response.returnCode !== 'FORGOT_OK') {
        throw new ApiError(
          response?.returnError ?? '',
          response.returnCode,
          response.rateLimit,
        );
      } else {
        return response;
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiPostForgottenPass'),
    );
};

/**
 * Forgotten password security level checker
 * @returns
 */
export const apiPostPassSecurityLevel = ({
  readablePassword,
}: {
  readablePassword: string;
}): Promise<IApiResponse<IPasswordZxcvbn, string>> => {
  const payload = {
    password: readablePassword,
  };
  const endpointClass = endpoints.password.postCheckPassSecurityLevel;
  return apiPost(endpointClass.getUrl(), payload, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<IPasswordZxcvbn, string>) => {
      if (response.returnCode !== 'PWD_CHK_OK' && response.returnCode !== 'PWD_CHK_OK_EMPTY') {
        throw new ApiError(
          response?.returnError ?? '',
          response.returnCode,
          response.rateLimit,
        );
      } else {
        return response;
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiPostPassSecurityLevel'),
    );
};
